var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.097,
    height: 16.775,
    viewBox: "0 0 15.097 16.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat_Color",
    "data-name": "Flat Color",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168012",
    "data-name": "Path 168012",
    d: "M13.871,3.677H8.839A.839.839,0,0,1,8.839,2h5.032a.839.839,0,0,1,0,1.677Z",
    transform: "translate(-0.806)",
    fill: "#e63946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168013",
    "data-name": "Path 168013",
    d: "M13.387,19.42H8.355A3.355,3.355,0,0,1,5,16.065V6H16.742V16.065A3.355,3.355,0,0,1,13.387,19.42Z",
    transform: "translate(-0.323 -0.645)",
    fill: "#e63946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168014",
    "data-name": "Path 168014",
    d: "M17.259,7.677H3.839A.839.839,0,0,1,3.839,6h13.42a.839.839,0,0,1,0,1.677Z",
    transform: "translate(0 -0.645)",
    fill: "#c9273a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_168374",
    "data-name": "Group 168374",
    transform: "translate(8.032 8.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168015",
    "data-name": "Path 168015",
    d: "M9.839,16.71A.839.839,0,0,1,9,15.871V10.839a.839.839,0,0,1,1.677,0v5.032A.839.839,0,0,1,9.839,16.71Z",
    transform: "translate(-9 -10)",
    fill: "#edebea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168016",
    "data-name": "Path 168016",
    d: "M13.839,16.71A.839.839,0,0,1,13,15.871V10.839a.839.839,0,0,1,1.677,0v5.032A.839.839,0,0,1,13.839,16.71Z",
    transform: "translate(-9.645 -10)",
    fill: "#edebea"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e0cb0bbe6a8a904bec23dc022be9adb5.svg";
export { ForwardRef as ReactComponent };